(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(90205);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 90205:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/shared/hooks/useToast.ts
var useToast = __webpack_require__(64390);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var index_esm = __webpack_require__(86893);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var dist_index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./src/shared/constants/routes.ts
var routes = __webpack_require__(224);
// EXTERNAL MODULE: ./src/modules/auth/hooks/useAuth.tsx + 3 modules
var useAuth = __webpack_require__(82221);
// EXTERNAL MODULE: ./src/shared/components/Form/FormGroup/index.tsx + 1 modules
var FormGroup = __webpack_require__(24293);
// EXTERNAL MODULE: ./src/shared/components/Form/ControlledInput/index.tsx
var ControlledInput = __webpack_require__(23058);
// EXTERNAL MODULE: ./src/shared/components/Button/index.tsx + 1 modules
var Button = __webpack_require__(67399);
// EXTERNAL MODULE: ./src/shared/components/AuthLink/index.tsx + 1 modules
var AuthLink = __webpack_require__(22025);
// EXTERNAL MODULE: ./src/shared/components/AuthHeader/index.tsx + 1 modules
var AuthHeader = __webpack_require__(41961);
;// CONCATENATED MODULE: ./src/modules/auth/pages/SignIn/index.tsx












const schemaValidation = es/* object */.Ry().shape({
    email: es/* string */.Z_().email("O formato do e-mail est\xe1 incorreto").required("E-mail \xe9 obrigat\xf3rio"),
    password: es/* string */.Z_().required("Senha \xe9 obrigat\xf3rio")
});
const SignIn = ()=>{
    const { control , formState: { isSubmitting , errors  } , handleSubmit  } = (0,dist_index_esm/* useForm */.cI)({
        defaultValues: {
            email: "",
            password: ""
        },
        resolver: (0,yup/* yupResolver */.X)(schemaValidation)
    });
    const { signIn  } = (0,useAuth/* useAuth */.a)();
    const handleSignIn = handleSubmit(signIn);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthHeader/* AuthHeader */.k, {
                title: "Seja bem vindo",
                subtitle: "Fa\xe7a o seu login para entrar no portal"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: handleSignIn,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* FormGroup */.c, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlledInput/* ControlledInput */.B, {
                            control: control,
                            icon: index_esm/* FiUser */.fzv,
                            name: "email",
                            placeholder: "Digite seu o e-mail",
                            error: errors.email,
                            autoComplete: "email",
                            size: "lg"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormGroup/* FormGroup */.c, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlledInput/* ControlledInput */.B, {
                            control: control,
                            icon: index_esm/* FiLock */.UIZ,
                            name: "password",
                            type: "password",
                            placeholder: "Digite a sua senha",
                            error: errors.password,
                            autoComplete: "current-password",
                            size: "lg"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        type: "submit",
                        mt: "md",
                        size: "lg",
                        isLoading: isSubmitting,
                        children: "Entrar"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthLink/* AuthLink */.g, {
                        href: routes/* routes.AUTH.PASSWORD_RECOVERY */._.AUTH.PASSWORD_RECOVERY,
                        icon: index_esm/* FiHelpCircle */.bax,
                        title: "Esqueci minha senha"
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./pages/index.tsx





const SignInPage = (param)=>{
    let { toastData  } = param;
    const toast = (0,useToast/* useToast */.p)();
    const router = (0,next_router.useRouter)();
    (0,react.useEffect)(()=>{
        const parsedToastData = JSON.parse(toastData);
        if (Object.values(parsedToastData).length > 0) {
            toast.show(parsedToastData);
            router.push({
                pathname: router.pathname
            }, undefined, {
                shallow: true
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        toastData
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SignIn, {});
};
var __N_SSP = true;
/* harmony default export */ var pages = (SignInPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7536,2735,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);